<template>
    <component
        :is="menuName"
        :dataInstagramDefault="dataInstagramDefault"
        @addSticker="addSticker"
        @updateSticker="updateSticker"
        @changeMenu="changeMenu"
    />
</template>

<script>

import selectSticker from './SelectStickerMenu.vue';
import localisationMenu from './LocalisationMenu.vue';
import musicMenu from './MusicMenu.vue';
import linkMenu from './LinkMenu.vue';
import imageMenu from './ImageMenu.vue';
import gifMenu from './GifMenu.vue';
import productMenu from './ProductMenu.vue';

export default {
    
    components: {
        selectSticker,
        localisationMenu,
        musicMenu,
        linkMenu,
        imageMenu,
        gifMenu,
        productMenu,
    },
    
    props: {
        menuNameDefault: {
            type: String,
            default: 'selectSticker'
        },
        dataInstagramDefault: Object
    },
    
    data() {
        return {
            menuName: 'selectSticker'
        }
    },
    
    methods: {
        addSticker(name, custom = {}) {
            if (!stickerDataDefault[name]) return
            this.$emit('addSticker', {...JSON.parse(JSON.stringify(stickerDataDefault[name])), ...custom})
            this.$emit('close');
        },

        updateSticker(id, payload) {
            this.$emit('updateSticker', id, payload)
        },
        
        changeMenu(menuName) {
            this.menuName = menuName
        }
    },

    watch: {
        menuNameDefault: {
            handler(newValue) {
                this.menuName = newValue
            },
            immediate: true
        }
    },
}

export const stickerDataDefault = {

    "text": {
        type:'text',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            text: '',
            font: 'modern-font',
            align: 'center',
            color: '#fff',
            fontSize: 27.5,
            background : 'secondary'
        },
    },

    "survey": {
        type:'survey',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            question : '',
            responses : ['oui','non']
        },
    },
    
    "localisation": {
        type:'localisation',
        isEditing: false,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            place : {},
        },
    },
    
    "mention": {
        type:'mention',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            place : {},
        },
    },
    "slider": {
        type:'slider',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            quesion : '',
            emoji: '😍'
        },
    },
    "hashtag": {
        type:'hashtag',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            hashtag : '',
        },
    },
    "link": {
        type:'link',
        isEditing: false,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            link : '',
            text: ''
        },
    },
    "product": {
        type:'product',
        isEditing: false,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            products : [],
        },
    },
    "image": {
        type:'image',
        isEditing: false,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            file: null,
            url: null,
        },
    },
    "gif": {
        type:'gif',
        isEditing: false,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            gif: null,
        },
    },

    "music": {
        type:'music',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            music: null,
        },
    }
}

</script>